export const getContent = (point) => {
  return `
    <h2 class="cpd-info-window-title">${point.label}</h1>
    <div class="cpd-info-window-content">
      <p><strong>Dirección</strong>: ${point.direccion}</p>
      <p><strong>Horario</strong>: ${point.horario}</p>
      <p><strong>Teléfono</strong>: ${point.telefono}</p>
    </div>
    <div class="cpd-info-window-link">
      <a href="https://www.google.com/maps/dir//${point.lat},${point.lng}" target="_blank" rel="noopener noreferrer">¿Cómo llegar?</a>
    </div>
  `;
};
